@use "app/styles/sticky" as sticky;

@include sticky.init;

:global(#header) {
  z-index: 99;
  position: relative;
  display: flex;
  height: sticky.$size;
  align-items: center;
  font-weight: 500;
  background-color: var(--color-background);
  margin: 0 calc(-1 * var(--root-gap));
  padding: 0 var(--root-gap);
  --section-color: var(--color-foreground);
  &::before {
    content: "";
    pointer-events: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.2s ease-out;
    background: var(--color-gray-dim);

    :global(.scrolled) & {
      opacity: 1;
    }
  }

  :global(.show-mobile-menu) & {
    visibility: visible;
    position: fixed;
    left: 0;
    right: 0;
    padding: 0 var(--root-gap);
    margin: 0;
    transform: none !important;
    background-color: var(--color-background);
  }

  @include sticky.supported {
    position: sticky;
    top: 0;
    transform: translateY(0);
    will-change: transform;
    @include sticky.animate(hide);
    @keyframes hide {
      to {
        transform: translateY(-100%);
      }
    }
  }

  img {
    width: 180px;
    height: 36px;

    @media (min-width: 48rem) and (min-height: 38rem) {
      width: 240px;
      height: 48px;
    }
  }
}

.pageLinks {
  display: none;

  :global(.show-mobile-menu) & {
    position: absolute;
    display: flex;
    height: sticky.$pageLinksHeight;
    top: sticky.$size;
    left: 0;
    right: 0;
    padding: 0 var(--root-gap);
    justify-content: space-around;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 500;
    background-image: linear-gradient(
      to bottom,
      var(--color-red-dark),
      var(--color-red-light)
    );

    a {
      color: var(--color-white);

      &:first-of-type {
        display: none;
      }
    }
  }

  @media (min-width: 48rem) and (min-height: 38rem) {
    gap: 2rem;
    display: flex;
    margin-right: 2rem;
  }

  a {
    padding: 1rem;
    text-decoration: none;
    &:hover {
      @media (pointer: fine) {
        text-decoration-line: underline;
        text-decoration-thickness: 2px;
      }
    }
  }
}

#hamburger {
  display: flex;
  border: none;
  height: 4rem;
  padding: 1rem 0.5rem;
  place-items: center;
  place-content: center;
  background: none;
  color: var(--color-foreground);

  &::before {
    display: block;
    content: "";
    height: 18px;
    width: 18px;
    mask-size: 100% 100%;
    mask-image: url(./hamburger.svg?no-inline);
    background-color: currentColor;
  }

  @media (min-width: 48rem) and (min-height: 38rem) {
    display: none;

    /* If the user expands their screen while the nav is open */
    :global(.show-mobile-menu) & {
      display: block;
    }
  }
}

:global(html.show-mobile-menu) {
  overflow: hidden;
  visibility: hidden;

  & > body {
    overflow: hidden;
  }
}

#logo {
  margin-right: auto;
}

#search {
  display: flex;
  place-items: center;
  place-content: center;
  flex-shrink: 1;
  @media (min-width: 64rem) and (min-height: 38rem) {
    width: 12.75rem;
  }

  :global(.show-mobile-menu) & {
    // This thing doesn't actually scroll but we preserve the scrollbar width
    overflow-y: auto;
    scrollbar-gutter: stable;
  }

  button {
    display: flex;
    justify-content: space-between;
    height: 4rem;
    width: 100%;
    padding: 1rem;
    background-origin: border-box;
    margin: 0;
    border-radius: 1.25rem;
    align-items: center;
    background-color: transparent;
    border: none;
    color: var(--color-foreground);
    -webkit-tap-highlight-color: transparent;
    @media (pointer: fine) {
      &:not(:disabled):is(:hover, :active, :focus) {
        color: var(--color-blue);
        border-color: transparent;
      }
    }
    & > kbd {
      font-family: inherit;
      font-size: 0.7rem;

      display: none;
    }
    &::before {
      content: "";
      display: block;
      height: 18px;
      width: 18px;
      margin-left: 0.2rem;
      mask-size: 100% 100%;
      mask-image: url(./search.svg?no-inline);
      background-color: var(--color-foreground);
    }
    @media (min-width: 64rem) and (min-height: 38rem) {
      & > kbd {
        display: inline-block;
      }
      border: 2px solid var(--color-foreground);
      height: 2.5rem;
      background:
        linear-gradient(var(--color-background), var(--color-background))
          padding-box,
        linear-gradient(120deg, var(--color-blue-alt), var(--color-blue))
          border-box !important;
    }
  }
}
